import { Shield, Key, Zap, ArrowRight, ArrowDown } from "lucide-react";
import { useTranslation } from "../../../i18n";

export default function AuthenticationFlow() {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              {t('routes.identity.authentication.title')}
            </h2>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center mr-4 mt-1">
                  <Shield className="h-4 w-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    {t('routes.identity.authentication.sections.0.title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('routes.identity.authentication.sections.0.description')}
                  </p>
                </div>
              </div>

              <div className="flex items-start">
                <div className="h-8 w-8 rounded-full bg-purple-100 flex items-center justify-center mr-4 mt-1">
                  <Zap className="h-4 w-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900 mb-2">
                    {t('routes.identity.authentication.sections.1.title')}
                  </h3>
                  <p className="text-gray-600">
                    {t('routes.identity.authentication.sections.1.description')}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="bg-gradient-to-br from-slate-50 to-blue-50 rounded-3xl p-8 border border-slate-200 shadow-lg">
              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  {t('routes.identity.authentication.flow.title')}
                </h3>
                <p className="text-gray-600">
                  {t('routes.identity.authentication.flow.description')}
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-center p-5 bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
                  <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-600 flex items-center justify-center text-white font-bold mr-4 shadow-lg">
                    1
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('routes.identity.authentication.flow.steps.0.title')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('routes.identity.authentication.flow.steps.0.description')}
                    </p>
                  </div>
                </div>

                <div className="flex justify-center">
                  <ArrowDown className="h-6 w-6 text-gray-400" />
                </div>

                <div className="flex items-center p-5 bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
                  <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold mr-4 shadow-lg">
                    2
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('routes.identity.authentication.flow.steps.1.title')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('routes.identity.authentication.flow.steps.1.description')}
                    </p>
                  </div>
                </div>

                <div className="flex justify-center">
                  <ArrowDown className="h-6 w-6 text-gray-400" />
                </div>

                <div className="flex items-center p-5 bg-white rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-all duration-300">
                  <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-purple-500 to-pink-600 flex items-center justify-center text-white font-bold mr-4 shadow-lg">
                    3
                  </div>
                  <div>
                    <h4 className="font-medium text-gray-900">
                      {t('routes.identity.authentication.flow.steps.2.title')}
                    </h4>
                    <p className="text-sm text-gray-600">
                      {t('routes.identity.authentication.flow.steps.2.description')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
